import { DetailedHTMLProps, LabelHTMLAttributes, HTMLProps } from "react"
import { cn } from "@/lib/utils"

export interface LabelProps<Values extends object | string>
	extends DetailedHTMLProps<
		LabelHTMLAttributes<HTMLLabelElement>,
		HTMLLabelElement
	> {
	hasError?: boolean
	required?: boolean
	htmlFor?: KeyOfObjectOrString<Values>
	/**
	 * Stacked gives a margin bottom to the element as it assumes an input will be below it, so the
	 * 	relationship between the label and input is a vertical one.
	 * Grouped meas that the label is used as part of a form group, so the relationship
	 * 	to label and input is a horizontal one.
	 * Solo assume the element is by itself so no margin or padding is added.
	 */
	positioning?: "stacked" | "grouped" | "solo"
}

export const Label = <Data extends object | string>({
	children,
	hasError,
	required = false,
	positioning = "stacked",
	className = "",
	...props
}: LabelProps<Data>) => (
	<label
		className={cn(
			"group block cursor-pointer text-sm",
			hasError
				? `text-red-600 hover:text-red-700`
				: `text-gray-700 hover:text-gray-900`,
			positioning === "stacked" && `mb-1`,
			className,
		)}
		{...props}
	>
		{children}
		{required === true && <>*</>}
	</label>
)

export const LabelSubtitle = ({
	className,
	...rest
}: HTMLProps<HTMLParagraphElement>) => {
	return (
		<p
			className={cn(
				"mt-1 mb-2 text-xs text-gray-500 group-hover:text-gray-700 md:w-8/12",
				className,
			)}
			{...rest}
		/>
	)
}
